import React from "react";
import U2000BasicDialog from "./U2000BasicDialog";

interface U2000HtmlDisplayDialogProps {
  isOpen: boolean;
  onClose: (reason: string) => void;
  title: string;
  /** URL du contenu HTML (affiché dans une iframe via src). */
  contentUrl?: string | null;
  /** Contenu HTML brut (affiché dans une iframe via srcdoc). Prend le pas sur contentUrl si fourni. */
  htmlContent?: string | null;
}

/**
 * Dialog dédié à l'affichage de contenu HTML (URL ou chaîne brute).
 * Taille : 75 % de la largeur et de la hauteur de l'écran.
 * UX : padding, zone de contenu délimitée (bordure légère, coins arrondis).
 */
const U2000HtmlDisplayDialog: React.FC<U2000HtmlDisplayDialogProps> = ({ isOpen, onClose, title, contentUrl, htmlContent }) => {
  if (!isOpen) return null;

  const hasContent = !!(htmlContent || contentUrl);

  return (
    <U2000BasicDialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width="w-[75vw]"
      height="h-[75vh]"
    >
      <div className="min-h-[calc(75vh-4rem)] h-full flex flex-col overflow-hidden p-4 md:p-5">
        {hasContent ? (
          <iframe
            title={title}
            src={htmlContent ? undefined : contentUrl ?? undefined}
            srcDoc={htmlContent ?? undefined}
            className="w-full flex-1 min-h-0 rounded-lg border border-gray-200 bg-white shadow-xs"
            sandbox="allow-same-origin"
          />
        ) : (
          <div className="flex-1 flex items-center justify-center text-gray-500 p-6 rounded-lg border border-gray-100 bg-gray-50">
            Aucun contenu à afficher.
          </div>
        )}
      </div>
    </U2000BasicDialog>
  );
};

export default U2000HtmlDisplayDialog;
